import { render } from "./insurance-plan.vue?vue&type=template&id=3f2d7f74&scoped=true&ts=true"
import script from "./insurance-plan.vue?vue&type=script&lang=ts"
export * from "./insurance-plan.vue?vue&type=script&lang=ts"

import "./insurance-plan.vue?vue&type=style&index=0&id=3f2d7f74&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2d7f74"]])

export default __exports__